import { inject, Injectable } from '@angular/core';
import { CONFIG_TOKEN } from '@pxl/models/common';
import { FavoriteReferenceDataService } from '@pxl/models/contracts';
import { FavoriteReferenceDataService as FavoriteReferenceDataBackendService, SpeciesModel } from '@pxl/shared/generated';
import { firstValueFrom } from 'rxjs';

@Injectable()
export class DefaultFavoriteReferenceDataService implements FavoriteReferenceDataService {
    private readonly favoriteReferenceDataBackendService = inject(FavoriteReferenceDataBackendService);
    private readonly config = inject(CONFIG_TOKEN);

    public getFavoriteSpecies(): Promise<SpeciesModel[]> {
        return firstValueFrom(this.favoriteReferenceDataBackendService.getFavoriteSpecies(this.config.API_VERSION));
    }
}
